//@ts-strict-ignore
//Wrapper around DiscountInput so we can also update the priceOrigin to MANUAL when a custom discount is set on a Sales Order/Quote.
import { useDispatch } from 'react-redux';
import React, { useContext } from 'react';
import ConnectedFormContext from '../Context/ConnectedFormContext';
import getIn from '../connectedForm/utils/getIn';
import getValue from '../connectedForm/utils/getValue';
import { IAbstractHeader, IAbstractLine, PriceOrigin } from '../../graphql/schema/p4types';
import * as input from '../connectedForm/inputComponents';
import { useRefFunction } from '../../utils/hooks';
import ICommonFieldProps from '../../@types/ICommonFieldProps';

type ICustomDiscountInputProps = ICommonFieldProps & {
  rowDataId: string;
  fieldId: 'termA' | 'termB' | 'termC' | 'termD' | 'termE';
  label?: string;
  readOnly: boolean;
  temporarySave: () => void; //Note - There is more complexity than this to the function, but this covers how it's used here for now.
  includeLabel?: boolean;
};

export const CustomDiscountInput = ({
  rowDataId,
  fieldId,
  label,
  readOnly,
  temporarySave,
  includeLabel,
  inputCols,
  labelCols,
}: ICustomDiscountInputProps) => {
  const dispatch = useDispatch();
  const connectedForm = useContext(ConnectedFormContext);
  const values: IAbstractHeader = connectedForm.values as IAbstractHeader;

  const rowValue = getIn(values, rowDataId) as IAbstractLine;

  const onBlur = useRefFunction((event) => {
    let value = (getValue(event) || '').replace(/[^\d.-]/g, '');
    if (value === '') {
      value = 0;
    }

    if (rowValue?.[fieldId] === Number(value)) {
      return;
    }

    const updates = [dispatch(connectedForm.change(`${rowDataId}.${fieldId}`, value))];
    if (rowValue?.priceOrigin !== PriceOrigin.Manual) {
      //Update price origin to manual_discount, but ONLY if price origin is not already manual (In that case, it should stay manual so we don't falsely present the option of creating a matrix.
      updates.push(dispatch(connectedForm.change(`${rowDataId}.priceOriginDescription`, 'Manual Discount')));
      updates.push(dispatch(connectedForm.change(`${rowDataId}.priceOrigin`, PriceOrigin.ManualDiscount)));
    }

    Promise.all(updates).then(temporarySave);
  });

  return (
    <input.DiscountInput
      value={rowValue?.[fieldId]}
      onBlur={onBlur}
      label={label}
      prefix={'-'}
      suffix={'%'}
      readOnly={readOnly}
      includeLabel={includeLabel}
      inputCols={inputCols}
      labelCols={labelCols}
    />
  );
};
